module.exports = __webpack_public_path__ + "static/a5-5e638ce36def286f6182f4ad328a7cdf.jpg";